// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../Config.bs.js";
import * as GeoRegionRepo from "./GeoRegionRepo.bs.js";
import * as DummyGeoRegionRepo from "./DummyGeoRegionRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return {
            fetchGeoRegions: DummyGeoRegionRepo.GeoRegionRepo.fetchGeoRegions,
            useGeoRegions: DummyGeoRegionRepo.GeoRegionRepo.useGeoRegions
          };
  } else {
    return GeoRegionRepo.GeoRegionRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
